import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PriceComponent} from './price.component';
import {CollapsibleDirective} from './collapsible.directive';
import {SvgComponent} from './svg/svg.component';
import {LazyImageDirective} from './lazy.image.directive';
import {SwipeMenuComponent} from './swipe-menu/swipe-menu.component';
import {SwipeDetectionDirective} from './swipe-detection';
import {DoorTypeToggle} from "./door-type-toggle";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IframeModalComponent} from "./iframe-modal.component";
import {SafePipe} from "./safe.pipe";
import {ProductTypeSelection} from "./product-type-selection";
import {ScenarioImagesComponent} from "./panels/desktop/scenario-panel/scenario-images.component";
import {DoorPanelComponent} from "./panels/desktop/door-panel/door-panel.component";
import {RefinePanelComponent} from "./panels/desktop/refine-panel/refine-panel.component";
import {VisualizeFooterComponent} from "./panels/desktop/visualize-footer/visualize-footer.component";
import {VisualizePanelComponent} from "./panels/desktop/visualize-panel/visualize-panel.component";
import {NgScrollbarModule} from "ngx-scrollbar";
import {TranslateModule} from "@ngx-translate/core";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {FilterModule} from "../panels/filter-panel/filter.module";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {QRCodeModule} from "angularx-qrcode";
import { WidgetScenarioImagesComponent } from './panels/widget/scenario-panel/scenario-images.component';
import { CustomAttributesFilterComponent } from './custom-attributes-filter/custom-attributes-filter.component';

// TODO: move to own DesktopPanelModule and move panels back to desktop folder
const panels = [
  ScenarioImagesComponent,
  DoorPanelComponent,
  CustomAttributesFilterComponent,
  RefinePanelComponent,
  VisualizeFooterComponent,
  VisualizePanelComponent,
  WidgetScenarioImagesComponent
];

@NgModule({
  declarations: [
    SvgComponent,
    PriceComponent,
    IframeModalComponent,
    CollapsibleDirective,
    LazyImageDirective,
    SafePipe,
    SwipeMenuComponent,
    SwipeDetectionDirective,
    DoorTypeToggle,
    ProductTypeSelection,
    ...panels
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgScrollbarModule.withConfig({ autoHeightDisabled: false, autoWidthDisabled: true }),
    TranslateModule,
    InfiniteScrollModule,
    ReactiveFormsModule,
    FilterModule,
    NgbModule,
    QRCodeModule
  ],
  exports: [
    SvgComponent,
    PriceComponent,
    DoorTypeToggle,
    ProductTypeSelection,
    CollapsibleDirective,
    LazyImageDirective,
    SwipeMenuComponent,
    SwipeDetectionDirective,
    ...panels
  ],
  providers: []
})
export class ComponentsModule {
}
